import { NumberBadge } from "@/components/badge/number-badge";
import { Divider } from "@/components/divider/divider";
import { useGetPlanStreaks } from "@/hooks/requests/plan/use-get-plan-streaks";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { IonSkeletonText } from "@ionic/react";
import { memo, useMemo } from "react";
import { SubCard } from "./sub-card";

const weekDays = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const ConsistencyCard = memo(function ConsistencyCard() {
  const { planStreaks, isLoading } = useGetPlanStreaks();
  const totalDays = 7;
  const weeklyCompletionDays = planStreaks?.weeklyCompletionDays ?? 0;
  const daysSinceFirstPlan = planStreaks?.daysSinceFirstPlan ?? 0;
  const currentStreakDays = planStreaks?.currentStreakDays ?? 0;
  const weekTickedOffDays = useMemo(() => {
    const completedDaysSet = new Set(planStreaks?.completedDays ?? []);
    return weekDays.map((day) => completedDaysSet.has(day));
  }, [planStreaks?.completedDays]);

  console.log("planStreaks", planStreaks);

  if (isLoading) {
    return <IonSkeletonText animated className="h-104 w-full rounded-2xl" />;
  }

  return (
    <div className="flex w-full flex-col items-center gap-4.5 rounded-[34px] border border-white p-2">
      <SubCard title="This Week">
        <div className="flex flex-col items-center gap-2">
          <h2
            className={cn(
              textVariants.bodySingleLine,
              "text-bold flex h-8 items-center !font-bold",
            )}
          >
            {weeklyCompletionDays} / {totalDays} days on plan
          </h2>

          <div className="flex h-6 items-center gap-2.5">
            {weekTickedOffDays.map((isCompleted, index) => (
              <div
                key={index}
                className={cn("flex h-6 w-6 rounded-full", {
                  "bg-gradient-to-b from-purple-700 to-[#593886]": isCompleted,
                  "border-2 border-[#60418A] bg-white": !isCompleted,
                })}
                style={isCompleted ? { backgroundColor: "var(--color-purple-700)" } : undefined}
              />
            ))}
          </div>
        </div>

        <p className={cn(textVariants.footnote, "flex h-8 items-center text-center")}>
          You're staying consistent this week
        </p>
      </SubCard>

      <SubCard title="Total Consistency" className="relative">
        <div className="flex flex-col items-center">
          <h2 className={cn(textVariants.title1, "h-7.5 font-bold text-[#502C82]")}>
            {daysSinceFirstPlan} days
          </h2>
          <p className={cn(textVariants.bodySmall, "h-8 font-bold")}>On plan overall</p>
        </div>

        <Divider className="absolute right-0 bottom-16 left-0 w-full" />

        <p className={cn(textVariants.footnote, "flex h-8 items-center gap-1")}>
          Current streak: <NumberBadge value={currentStreakDays} /> days
        </p>
      </SubCard>
    </div>
  );
});
